import { clipboard, isIOS, openLink, share } from "@luce/core";
import { toast } from "@luce/ui";

import type { LinkShareChannel, ShareChannel } from "./types";

const LUCE_APP_URL = "https://app.luce.sg/";

function channelUrl(channel: LinkShareChannel, text: string): string {
  switch (channel) {
    case "whatsapp":
      return `https://wa.me/?text=${text}`;
    case "telegram":
      return `https://t.me/share/url?url=${LUCE_APP_URL}&text=${text}`;
    case "messenger":
      return `https://m.me/lucegroupsg?text=${text}`;
    case "sms":
      return isIOS ? `sms:&body=${text}` : `sms:?body=${text}`;
  }
}

export function useShareMessage(message: string, onShare?: (channel: ShareChannel) => void) {
  const shareTo = (channel: LinkShareChannel) => {
    openLink(channelUrl(channel, encodeURIComponent(message)));
    onShare?.(channel);
  };

  const shareOther = async () => {
    const result = await share({ url: LUCE_APP_URL, message });
    if (result.error) toast.error("Sharing isn't available on this device");
    onShare?.("other");
  };

  const copy = async () => {
    const result = await clipboard.copy(message);
    if (result.success) toast.success("Copied to clipboard");
    else toast.error("Failed to copy");
    onShare?.("copy");
  };

  return { shareTo, shareOther, copy };
}
